module.exports = __webpack_public_path__ + "img/DNSC_LOGO.445f4efd.png";